import { type ReactNode, useRef } from 'react';
import toast from 'react-hot-toast';

import ActionForm from '~/components/ActionForm';
import { useComponentFetcher } from '~/components/ComponentErrorBoundary/useComponentFetcher';
import type { Product } from '~/interfaces/product';
import { useClientSecretContext } from '~/routes/products/_hooks/useClientSecretConext';

interface BuyNowActionProps {
  product: Product;
  children: ReactNode | ReactNode[];
}

const BuyNowAction = ({ product, children }: BuyNowActionProps) => {
  const fetcher = useComponentFetcher();
  const formRef = useRef<HTMLFormElement>(null);
  const { setClientSecret } = useClientSecretContext();

  return (
    <ActionForm
      fetcher={fetcher}
      formRef={formRef}
      method="post"
      action={`/products/${product.slug}`}
      onSuccess={(data) => {
        if (data.clientSecret && setClientSecret) {
          setClientSecret(data.clientSecret);
        }
      }}
      onError={(data) => {
        toast.error(data?.toast?.message || 'Something went wrong, please try again');
      }}
    >
      <input type="hidden" name="product_variant_id" value={product?.default_product_variant?.id || ''} />
      {children}
    </ActionForm>
  );
};

export default BuyNowAction;
